export const GET_STAFF_BY_EMAIL = "GET_STAFF_EMAIL";
export const GET_STAFF_BY_EMAIL_SUCCESS = "GET_STAFF_EMAIL_SUCCESS";
export const GET_STAFF_BY_EMAIL_FAIL = "GET_STAFF_EMAIL_FAIL";

export const GET_LANG_TIME_ZONE = "GET_LANG_TIME_ZONE";
export const GET_LANG_TIME_ZONE_SUCCESS = "GET_LANG_TIME_ZONE_SUCCESS";
export const GET_LANG_TIME_ZONE_FAIL = "GET_LANG_TIME_ZONE_FAIL";
